<template>
	<div>
		<div class="head f-ct">
			<div class="tianqi f-bct">
				<div class="l f-ct">
					<span>当前时间：</span>
					<!-- <span>当前位置：广州</span> -->
					<!-- <el-image class="i1" :src="require('@/static/img3.png')"></el-image>
					<span>15℃~28℃ | 空气质量</span>
					<el-image class="i2" :src="require('@/static/img4.png')"></el-image> -->
					<span>{{nowYear}}年{{nowMonth}}月{{strDate}}日 {{xinqi}}</span>
				</div>
				<div class="r" @click="link('/userHome')" v-if="userInfo.member||userInfo.company">
					<template v-if="userType==1">
						欢迎回来，{{userInfo.member.name}}<span>海南省燃气从业人员培训教育信息平台</span>
					</template>
					<template v-if="userType==2">
						欢迎回来，{{userInfo.company.companyName}}<span>海南省燃气从业人员培训教育信息平台</span>
					</template>
				</div>
				<div class="rlogin" v-else>
					<el-image class="icon" :src="require('@/static/icon16.png')"></el-image>
					<div class="loginBtn">
						<div class="btnDef f-ct" @click="link('/login')">
							<el-image class="i2" :src="require('@/static/icon14h.png')"></el-image>
							<el-image class="i1" :src="require('@/static/icon14.png')"></el-image>
							<span>登录</span>
						</div>
						<div class="btnDef f-ct" @click="link('/reg')">
							<el-image class="i2" :src="require('@/static/icon15h.png')"></el-image>
							<el-image class="i1" :src="require('@/static/icon15.png')"></el-image>
							<span>注册</span>
						</div>
					</div>
				</div>
			</div>
			<el-image class="banner" :src="require('@/static/icon13.jpg')"></el-image>
			<div class="navBox f-ct">
				<div class="itm" :class="selIdx==1?'a':''" @click="link('/home')">首页</div>
				<div class="itm" :class="selIdx==2?'a':''" @click="link('/dynamic')">协会概况</div>
				<div class="itm" :class="selIdx==3?'a':''" @click="link('/newsList')">新闻中心</div>
				<div class="itm" :class="selIdx==4?'a':''" @click="link('/industryList')">人才交流</div>
				<div class="itm" :class="selIdx==5?'a':''" @click="link('/study')">培训教育</div>
				<div class="itm" :class="selIdx==6?'a':''" @click="link('/safetyList')">安全管理</div>
				<div class="itm" :class="selIdx==7?'a':''" @click="link('/skillList')">技术服务</div>
				<div class="itm" :class="selIdx==8?'a':''" @click="link('/exhibition')">燃气展会</div>
				<div class="itm" :class="selIdx==9?'a':''" @click="link('/cardSeach')">证书查询</div>
				<div class="itm" :class="selIdx==10?'a':''" @click="link('/download')">下载中心</div>
			</div>
		</div>
	</div>
</template>
<script>
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	name: "Head",
	data(){
		return {
			selIdx:1,
			bigPageHistory:[],
			nowYear:'',
			nowMonth:'',
			strDate:'',
			xinqi:'',
		}
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	},
	watch: {
		'$route': function(n,o) {
			// console.log('n',n.path)
			// console.log('o',o.path)
			if (localStorage.getItem('bigPageHistory')) {
				var arr = localStorage.getItem('bigPageHistory')
				arr = JSON.parse(arr)
				this.bigPageHistory = arr
			}
			if(
			n.path=='/home'||
			n.path=='/dynamic'||
			n.path=='/newsList'||
			n.path=='/industryList'||
			n.path=='/study'||
			n.path=='/safetyList'||
			n.path=='/skillList'||
			n.path=='/exhibition'||
			n.path=='/cardSeach'||
			n.path=='/download'
			){
				this.bigPageHistory = []
			}
			if(this.bigPageHistory.length){
				if(n.path!=this.bigPageHistory[this.bigPageHistory.length-1]){
					this.bigPageHistory.push(n.path)
				}
			}else{
				this.bigPageHistory.push(n.path)
			}
			localStorage.setItem("bigPageHistory", JSON.stringify(this.bigPageHistory));
			// console.log(this.bigPageHistory)
			
			
			if(this.bigPageHistory[0]=='/home'){
				this.selIdx = 1
			}
			if(this.bigPageHistory[0]=='/dynamic'){
				this.selIdx = 2
			}
			if(this.bigPageHistory[0]=='/newsList'){
				this.selIdx = 3
			}
			if(this.bigPageHistory[0]=='/industryList'){
				this.selIdx = 4
			}
			if(this.bigPageHistory[0]=='/study'){
				this.selIdx = 5
			}
			if(this.bigPageHistory[0]=='/safetyList'){
				this.selIdx = 6
			}
			if(this.bigPageHistory[0]=='/skillList'){
				this.selIdx = 7
			}
			if(this.bigPageHistory[0]=='/exhibition'){
				this.selIdx = 8
			}
			if(this.bigPageHistory[0]=='/cardSeach'){
				this.selIdx = 9
			}
			if(this.bigPageHistory[0]=='/download'){
				this.selIdx = 10
			}
			
		}
	},
	mounted() {
		// 获取 页面 浏览历史
		// console.log(localStorage.getItem('bigPageHistory'))
		if (localStorage.getItem('bigPageHistory')) {
			var arr = localStorage.getItem('bigPageHistory')
			arr = JSON.parse(arr)
			this.bigPageHistory = arr
		}
		if(
		this.$route.path=='/home'||
		this.$route.path=='/dynamic'||
		this.$route.path=='/newsList'||
		this.$route.path=='/industryList'||
		this.$route.path=='/study'||
		this.$route.path=='/safetyList'||
		this.$route.path=='/skillList'||
		this.$route.path=='/exhibition'||
		this.$route.path=='/cardSeach'||
		this.$route.path=='/download'
		){
			this.bigPageHistory = []
		}
		if(this.bigPageHistory.length){
			if(this.$route.path!=this.bigPageHistory[this.bigPageHistory.length-1]){
				this.bigPageHistory.push(this.$route.path)
			}
		}else{
			this.bigPageHistory.push(this.$route.path)
		}
		localStorage.setItem("bigPageHistory", JSON.stringify(this.bigPageHistory));
		// console.log(this.bigPageHistory)
		
		
		
		
		if(this.bigPageHistory[0]=='/home'){
			this.selIdx = 1
		}
		if(this.bigPageHistory[0]=='/dynamic'){
			this.selIdx = 2
		}
		if(this.bigPageHistory[0]=='/newsList'){
			this.selIdx = 3
		}
		if(this.bigPageHistory[0]=='/industryList'){
			this.selIdx = 4
		}
		if(this.bigPageHistory[0]=='/study'){
			this.selIdx = 5
		}
		if(this.bigPageHistory[0]=='/safetyList'){
			this.selIdx = 6
		}
		if(this.bigPageHistory[0]=='/skillList'){
			this.selIdx = 7
		}
		if(this.bigPageHistory[0]=='/exhibition'){
			this.selIdx = 8
		}
		if(this.bigPageHistory[0]=='/cardSeach'){
			this.selIdx = 9
		}
		if(this.bigPageHistory[0]=='/download'){
			this.selIdx = 10
		}
		
		console.log(this.userInfo)
		// 获取当前日期
		var date = new Date();
		this.nowYear = date.getFullYear();
		this.nowMonth = date.getMonth() + 1;
		this.strDate = date.getDate();
		var xinqi = date.getDay();
		var arr = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
		this.xinqi = arr[xinqi]
		
	},
	methods:{
		
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.head{
	width: 100%;
	.tianqi{
		width: 100%;
		padding: 0 360px;
		height: 40px;
		background: #fff;
		.l{
			font-size: 14px;
			color: #4D546C;
			.i1{
				width: 30px;
				height: 30px;
				margin:  0 2px;
			}
			.i2{
				width: 20px;
				height: 20px;
				margin-left: 10px;
				margin-right: 14px;
			}
		}
		.r{
			color: #333333;
			font-size: 14px;
			span{
				text-decoration:underline;
				color: #3B6492;
				padding-left: 10px;
				cursor: pointer;
			}
		}
		.rlogin{
			position: relative;
			width: 124px;
			height: 100%;
			// background: pink;
			.icon{
				width: 23px;
				height: 27px;
				position: absolute;
				left: -11px;
				top: 20px;
			}
			.loginBtn{
				width: 124px;
				height: 140px;
				margin-top: 20px;
				background: #FFFFFFBF;
				position: relative;
				z-index: 3;
				border-radius: 0 0 10px 10px;
				padding-top: 22px;
				.btnDef{
					width: 100px;
					height: 44px;
					border-radius: 44px;
					border: 2px solid #3B6492;
					margin: auto;
					margin-bottom: 16px;
					justify-content: center;
					cursor: pointer;
					transition:0.3s;
					&:hover{
						box-shadow: 0px 2px 16px 0px #3B6492B2;
						background: #3B6492;
						transition:0.3s;
						span{
							color: #fff;
						}
						.i1{display: none;}
						.i2{display: block;}
					}
					.i1{display: block;}
					.i2{display: none;}
					.el-image{
						width: 24px;
						height: 24px;
						margin-right: 8px;
					}
					span{
						font-size: 16px;
						color: #3B6492;
					}
				}
			}
		}
	}
	.banner{
		width: 100%;
		height: 248px;
	}
	.navBox{
		width: 100%;
		padding: 0 360px;
		margin-top: -48px;
		height: 48px;
		position: relative;
		z-index: 2;
		background: #0000004D;
		.itm{
			width: 120px;
			height: 100%;
			text-align: center;
			line-height: 48px;
			font-size: 16px;
			color: #fff;
			font-weight: 500;
			cursor: pointer;
		}
		.a{
			background: #E86F26;
		}
	}
}
</style>